import { Injectable } from "@angular/core";

import { AuthCoreService } from "anatoliapps-angular/auth";

/**
 * Service responsible for managing authentication operations and user state
 * Handles user authentication, registration, profile updates, and password management
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService extends AuthCoreService {

  //#region Constructor
  /**
   * Initializes the authentication service
   */
  constructor() {
    super();
  }
  //#endregion

}